import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});


const options = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significantly more fragmented',
        data: [0, 0 ,0]
    },{
        name: 'Somewhat more fragmented',
        data: [6, 12, 8]
    },{
        name: 'No change',
        data: [0, 16, 19]
    },{
        name: 'Somewhat more cohesive',
        data: [63, 49, 38]
    },{
        name: 'Significantly more cohesive',
        data: [31, 23, 35]
    }]
}

const interaction = {
  chart: {
        type: 'column'
    },
    title: {
        text: 'In-region foreign investment deals in SEA (2017) (Investor-side)'
    },
    xAxis: {
        categories: ['Indonesia', 'Malaysia', 'Philippines', 'Singapore', 'Thailand']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Number of deals'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Location of investors providing in-region foreign investment',
        data: [12, 2, 3, 13, 1]
    }]
}
const interaction2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: 'In-region foreign investment deals in SEA (2017) (Startup-side)'
    },
    xAxis: {
        categories: ['Indonesia', 'Malaysia', 'Singapore', 'Thailand']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Number of deals'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Location of startup receiving in-region foreign investment',
        data: [9, 6, 15, 1]
    }]
}

export class ChapterThirtyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>


        <TextHolder text="A significant majority of survey respondents in all categories felt that SEA’s international tech community had become “significantly” or “somewhat” more cohesive in recent years. Community builders were the most positive, with 94 percent of them answering that cohesion had increased." />
        <TextHolder text="" />


                  <Highchartscomponent options={options} chartsText="How has the SEA tech community’s degree of interaction between countries evolved over the last five years?"  chartsBottomText="Cross-border investments within SEA increased, with Singapore-based investors leading the way. These investors led 13 out of 31 total in-region foreign investment deals, focusing mostly on Indonesia. Indonesia-based investors came a close second, leading with 12 deals."  source="Source: 2018 State of SE Asian Tech Survey" />

                  <Highchartscomponent options={interaction}  chartsBottomText="Meanwhile, more deal activity flowed into Singapore than out of it. Singapore-based startups received the most deals from in-region foreign investors—15 deals to Indonesia’s nine." notes="Notes: Funding amount extrapolated based on assumption of equal contribution from all parties for a given round" source={<p>Source: <a href="https://www.funderbeam.com">Funderbeam</a>, Slush Singapore analysis</p>} />


                  <Highchartscomponent options={interaction2}  notes="Notes: Funding amount extrapolated based on assumption of equal contribution from all parties for a given round" source={<p>Source: <a href="https://www.funderbeam.com">Funderbeam</a>, Slush Singapore analysis</p>} />

                  <TextHolder text="" />
                  <TextHolder text="However, barriers to integration remain. Some of the most stubborn hurdles are language and other cultural differences, said Paul Hadjy, founder and CEO of Horangi. “In different countries problems are solved in different ways, often times they are very relationship driven. This basically means you have to be on the ground, or hire someone who can act as you do develop those relationships,” he said." />

                  <TextHolder text="Laws and regulations in some countries can impede integration as well. 'Taxation between member countries, especially on capital gains, should be ‘friendlier’ to VCs. Standardization in legal affairs, for example, could speed up the investment process,' said Nizar Ali, managing director of FirstFloor Capital." />
                  <TextHolder text="" />

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/31.js